import React, { Component, Fragment } from 'react';
import { Radio, Icon, Row, Col, Button, Table, Card } from 'antd';
import { Link } from 'react-router-dom';
import { filter } from 'ramda';
import { withAsyncActions } from 'react-async-client';

import { getApplications } from 'actions/asyncActions';
import { project_application, project_application_add, project_application_edit } from 'constants/routes';
import Date from 'components/common/fields/Date';
import {mapIndexed} from 'utils/ramdaAdditions.js';
import Breakpoint from 'components/layout/Breakpoint.js';

function TableCardProjectView(application, index, projectId) {
    return (
        <Card className="table-card" key={application.id}>
            <Row type="flex" justify="space-between">
                <span className="index">{index + 1}</span>
                <Link to={project_application.stringify({
                    id: application.id,
                    project_id: projectId
                })}>
                    <Icon type="eye-o" />
                </Link>
            </Row>
            <Row className="bold m-t-10">
                <Link to={project_application.stringify({
                    id: application.id,
                    project_id: projectId
                })}>
                    {application.name}
                </Link>
            </Row>
            <Row className="table-card-inline m-t-10">
                <span className="key">{APPLICATION_STATUSES[application.status_price]}</span>
            </Row>
            <Row className="key m-t-20">
                <Date date={application.finishing_date} />
            </Row>
        </Card>
    );
}

@withAsyncActions({
    getApplications: getApplications
        .withPayload(({ id }) => id),
}, { dispatchOnMount: true })
export default class Applications extends Component {
    state = {
        finished: 0
    }

    goAddRequest = () => {
        const { id, regionName } = this.props;
        this.props.history.push(project_application_add.stringify({ project_id: id, region_name: regionName.toLowerCase() }));
    }

    columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            className: 'bold',
        },
        {
            title: 'Название',
            dataIndex: 'name',
            key: 'name',
            render: (value, row) => (
                <Link to={project_application.stringify(row)}>
                    {value}
                </Link>
            ),
        },
        {
            title: 'Статус покупки',
            dataIndex: 'status_price',
            key: 'status_price',
            className: 'table-wrap',
            render: v => APPLICATION_STATUSES[v]
        },
        {
            title: 'Дата завершения',
            dataIndex: 'finishing_date',
            key: 'date',
            className: 'bold',
            render: v => v ? <Date date={v} /> : ' — '
        },
        {
            title: 'Действие',
            dataIndex: 'actions',
            key: 'actions',
            render: (value, row) => (
                <div className="table-actions">
                    <Link to={project_application.stringify(row)}>
                        <Icon type="eye-o" />
                    </Link>
                    <Link to={project_application_edit.stringify(row)}>
                        <Icon type="edit" />
                    </Link>
                </div>
            )
        },
    ];

    changeFilter = (event) => {
        const finished = event.target.value;
        this.setState({
            finished,
        });
    }

    render() {
        const { finished } = this.state;
        const {id} = this.props;
        const { data: { applications = [] }, meta } = this.props.getApplications;

        const dataSource = filter((i) => {
            if (finished) return i.status_price === 'COMPLETE';
            return i.status_price !== 'COMPLETE';
        }, applications);
        
        return (
            <Fragment>
                <Row className="controls m-t-30">
                    <Col xs={24}>
                        <div className="table-title">Заявки</div>
                    </Col>
                    <Col xs={24}>
                        <Radio.Group value={finished} onChange={this.changeFilter}>
                            <Radio.Button value={0}>Текущие</Radio.Button>
                            <Radio.Button value={1}>Завершенные</Radio.Button>
                        </Radio.Group>
                    </Col>
                    <Col xs={24}>
                        <Button type="primary" onClick={this.goAddRequest}>
                            Добавить заявку <Icon type="plus" />
                        </Button>
                    </Col>
                </Row>
                <Breakpoint min="sm">
                    <Table
                        rowKey='id'
                        columns={this.columns}
                        loading={meta.pending}
                        dataSource={dataSource}
                        pagination={false}
                    />
                </Breakpoint>
                <Breakpoint max="sm">
                    {mapIndexed((data, i) => TableCardProjectView(data, i, id), dataSource)}
                </Breakpoint>
            </Fragment>
        );
    }
}

const APPLICATION_STATUSES = {
    'SENT': 'Новая заявка',
    'REJECTED_PAYMENT': 'Приложенный документ не подтверждает факта оплаты заявки',
    'REJECTED_DOC_TYPE': 'Приложенный документ не соответствует конкретной заявке',
    'REJECTED_NO_PAYMENT': 'Заявка не была оплачена',
    'REJECTED_REVOKED_PAYMENT': 'Заявка была оплачена, но позже был осуществлен возврат',
    'ACCEPTED': 'Принята',
    'SHIPPED': 'Заявка отгружена',
    'PAID_PART': 'Заявка оплачена частично',
    'COMPLETE': 'Заявка завершена'
}



// WEBPACK FOOTER //
// ./src/components/pages/projects/Applications.js